import React, { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { classNames } from '../tools/helpers';
import { getService, getSite } from '../tools/fetcher';
import Button from './Button';

export default function Service({ className }) {
    const [services, setServices] = useState([]);
    const { data } = useQuery({
        queryKey: ['sites'],
        queryFn: getSite,
    });

    useEffect(() => {
        getService().then((result) => {
            if (!result?.code) {
                const dt = result.map((d) => ({
                    title: d?.title?.rendered,
                    description: d?.service_details?.description,
                    imageSrc: d?.service_details?.image_src,
                    imageAlt: d?.service_details?.image_alt,
                    linkUrl: d?.service_details?.link_url,
                }));
                setServices(dt);
            }
        });
    }, []);

    return (
        <div className={classNames('space-y-8 sm:space-y-[60px]', className)}>
            <div className={'flex flex-col gap-2 items-center sm:gap-4'}>
                <p
                    className={
                        'font-bold leading-[36px] text-center text-[32px] text-primary-black-100 sm:leading-[52px] sm:text-[40px]'
                    }
                >
                    {data?.service?.title}
                </p>
                <p className={'max-w-[648px] text-center text-primary-gray-101'}>{data?.service?.description}</p>
            </div>
            <div
                className={
                    'gap-6 grid grid-cols-1 items-end justify-center w-full sm:grid-cols-2 lg:gap-0 lg:grid-cols-3'
                }
            >
                {services.map((service, index) => {
                    const title = service.title?.split('|') || [];
                    return (
                        <div
                            key={index}
                            className={
                                'bg-white drop-shadow-[0.25em] p-8 rounded-2xl space-y-2 w-full'
                            }
                        >
                            <div
                                className={'bg-gradient-to-b from-primary-blue-101 to-primary-blue-102 flex items-center justify-center mb-6 rounded-full h-10 w-10 sm:h-[60px] sm:w-[60px]'}>
                                <img
                                    src={service.imageSrc}
                                    alt={service.imageAlt}
                                />
                            </div>
                            <p
                                className={
                                    'font-bold leading-7 text-xl text-primary-black-100'
                                }
                            >
                                {title[0]}
                            </p>
                            <div className={'leading-6 text-primary-gray-101'}>
                                {service.description?.split('|').map((desc, idx) => (
                                    <li key={idx} className={'leading-8'}>{desc}</li>
                                ))}
                            </div>
                            <Button
                                type="a"
                                href={service.linkUrl}
                                className={classNames('bg-gradient-to-r from-primary-black-101 to-primary-black-102 sm:h-[60px] sm:px-8',
                                    index === 1 ? 'mt-6 lg:mt-[64px]' : 'mt-6')
                                }
                                target="_blank"
                            >
                                {title[1]}
                            </Button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
